// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-container {
    /* max-height: calc(100vh - 365px);
    overflow: auto; */
    width:100%;
}

table {
    /* overflow-x: scroll; */
    border-collapse: collapse;
    /* width:100% */
}

.tableWidth {
  width:1000px;
}



td, th {
    border: 1px solid black;
    text-align: left;
    font-weight: normal;
    width: 70px;
    padding: 4px 4px 4px 4px;

}

th {
    /* border-top: none; */
    position: sticky;
    top: 0;
    background: #212529;
    color: #ffffff;
    z-index: 1;
    /* width:40px */
}

tbody tr:nth-child(even) {
    background-color: #f2f2f2;
}

td .txtarea {
    width: 100% !important;
}

td textarea:hover {
    border: 1px solid gray !important;
}

.first td:nth-child(1) {
    color: teal;
}


.scrollit {
    overflow-x:scroll;
    /* height:100px; */
}

.navHead {
    color: teal;
    font-size: 20px;
    font-weight: bold;
}

body {
    margin: 0;
    padding: 0;
    color: black;
    font-size: 144px;
    font-weight: bold;
  }
  
  
.marquee {
    /* width: 100%; */
    white-space: nowrap;
    overflow: hidden;

    /* position: absolute;
    width:100%; */
  }
  
  .marquee table {
    display:inline-block;

    /* padding-left: 20%; */
    /* padding-left: 100%; */
    /* show the marquee just outside the paragraph */
    /* will-change: transform;*/
    width: max-content;

    padding-left: 100%;
    animation: marquee 110s linear infinite;
  
  }
  
  @keyframes marquee {
    /* 0% { 
        transform: translateX(100%);       
        }  
    100% {
      transform: translateX(-100%);
    } */
    0% { transform: translate(0, 0); }
    100% { transform: translate(-100%, 0); }

  }
  
  .marquee:hover table{
    animation-play-state: paused;
  }

  .scrollTable:hover{
    overflow-x: scroll;  
  }


/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/View/core/live-update/live-update.component.css"],"names":[],"mappings":"AAAA;IACI;qBACiB;IACjB,UAAU;AACd;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;EACE,YAAY;AACd;;;;AAIA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,wBAAwB;;AAE5B;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,MAAM;IACN,mBAAmB;IACnB,cAAc;IACd,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,WAAW;AACf;;;AAGA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;EACnB;;;AAGF;IACI,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;;IAEhB;iBACa;EACf;;EAEA;IACE,oBAAoB;;IAEpB,uBAAuB;IACvB,wBAAwB;IACxB,gDAAgD;IAChD,2BAA2B;IAC3B,kBAAkB;;IAElB,kBAAkB;IAClB,uCAAuC;;EAEzC;;EAEA;IACE;;;;;OAKG;IACH,KAAK,0BAA0B,EAAE;IACjC,OAAO,8BAA8B,EAAE;;EAEzC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;EACpB;;;AAGF,wiIAAwiI","sourcesContent":[".table-container {\r\n    /* max-height: calc(100vh - 365px);\r\n    overflow: auto; */\r\n    width:100%;\r\n}\r\n\r\ntable {\r\n    /* overflow-x: scroll; */\r\n    border-collapse: collapse;\r\n    /* width:100% */\r\n}\r\n\r\n.tableWidth {\r\n  width:1000px;\r\n}\r\n\r\n\r\n\r\ntd, th {\r\n    border: 1px solid black;\r\n    text-align: left;\r\n    font-weight: normal;\r\n    width: 70px;\r\n    padding: 4px 4px 4px 4px;\r\n\r\n}\r\n\r\nth {\r\n    /* border-top: none; */\r\n    position: sticky;\r\n    top: 0;\r\n    background: #212529;\r\n    color: #ffffff;\r\n    z-index: 1;\r\n    /* width:40px */\r\n}\r\n\r\ntbody tr:nth-child(even) {\r\n    background-color: #f2f2f2;\r\n}\r\n\r\ntd .txtarea {\r\n    width: 100% !important;\r\n}\r\n\r\ntd textarea:hover {\r\n    border: 1px solid gray !important;\r\n}\r\n\r\n.first td:nth-child(1) {\r\n    color: teal;\r\n}\r\n\r\n\r\n.scrollit {\r\n    overflow-x:scroll;\r\n    /* height:100px; */\r\n}\r\n\r\n.navHead {\r\n    color: teal;\r\n    font-size: 20px;\r\n    font-weight: bold;\r\n}\r\n\r\nbody {\r\n    margin: 0;\r\n    padding: 0;\r\n    color: black;\r\n    font-size: 144px;\r\n    font-weight: bold;\r\n  }\r\n  \r\n  \r\n.marquee {\r\n    /* width: 100%; */\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n\r\n    /* position: absolute;\r\n    width:100%; */\r\n  }\r\n  \r\n  .marquee table {\r\n    display:inline-block;\r\n\r\n    /* padding-left: 20%; */\r\n    /* padding-left: 100%; */\r\n    /* show the marquee just outside the paragraph */\r\n    /* will-change: transform;*/\r\n    width: max-content;\r\n\r\n    padding-left: 100%;\r\n    animation: marquee 110s linear infinite;\r\n  \r\n  }\r\n  \r\n  @keyframes marquee {\r\n    /* 0% { \r\n        transform: translateX(100%);       \r\n        }  \r\n    100% {\r\n      transform: translateX(-100%);\r\n    } */\r\n    0% { transform: translate(0, 0); }\r\n    100% { transform: translate(-100%, 0); }\r\n\r\n  }\r\n  \r\n  .marquee:hover table{\r\n    animation-play-state: paused;\r\n  }\r\n\r\n  .scrollTable:hover{\r\n    overflow-x: scroll;  \r\n  }\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
